import { render } from "./polls.vue?vue&type=template&id=2cab3b37&lang=pug"
import script from "./polls.vue?vue&type=script&setup=true&lang=js"
export * from "./polls.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__